import { getAuthUrl } from './authUrl'
import { getDailyMissionUrl } from './dailyMissionUrl'
import { getMissionUrl } from './missionUrl'
import { getNEISUrl } from './neisUrl'
import { getNoticeUrl } from './noticeUrl'
import { getUserConsultBlockUrl } from './userConsultBlockUrl'
import { getUserUrl } from './userUrl'
import { getChatUrl } from './chatUrl'
import { getTypeTestUrl } from './typeTestUrl'
import { getReportUrl } from './reportUrl'
import { getNotificationUrl } from './notificationUrl'
import { getUserSSEUrl } from './userSSEUrl'

const BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

const api = {
  auth: getAuthUrl(BASE_URL),
  mission: getMissionUrl(BASE_URL),
  neis: getNEISUrl(BASE_URL),
  user: getUserUrl(BASE_URL),
  notice: getNoticeUrl(BASE_URL),
  dailyMission: getDailyMissionUrl(BASE_URL),
  userConsultBlock: getUserConsultBlockUrl(BASE_URL),
  chat: getChatUrl(BASE_URL),
  typeTest: getTypeTestUrl(BASE_URL),
  report: getReportUrl(BASE_URL),
  notification: getNotificationUrl(BASE_URL),
  userSSE: getUserSSEUrl(BASE_URL)
}

export default api
